




import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import { Widget } from '@xsolla/login-sdk';

import { LoginScope, ResponseType } from '@/constants/xsolla';
import { Apps } from '@/constants/apps';
import { TOWNSHIP_CUSTOM_LABELS_URL } from '@/config/xsolla';

interface WidgetConfig {
  projectId: string;
  clientId?: number;
  callbackUrl?: string;
  redirectUri?: string;
  scope: string;
  responseType: string;
  state?: string;
  payload?: string;
  preferredLocale?: string;
  settingsJSON?: string;
  socialsJSON?: string;
  customLabels?: string;
  theme?: {
    scene?: {
      color?: string;
    };
  };
}

@Component
export default class XsollaWidget extends Vue {
  @Prop({ type: String, required: true })
  readonly projectId!: string;

  @Prop({ type: Number })
  readonly clientId?: number;

  @Prop({ type: String })
  readonly preferredLocale?: string;

  @Prop({ type: String })
  readonly callbackUrl?: string;

  @Prop({ type: String })
  readonly redirectUri?: string;

  @Prop({ type: String })
  readonly state?: string;

  @Prop({ type: String })
  readonly payload?: string;

  @Prop({ type: String, default: LoginScope.OFFLINE })
  readonly scope!: string;

  @Prop({ type: String, default: ResponseType.CODE })
  readonly responseType!: string;

  @Prop({ type: Boolean })
  readonly lazy!: boolean;

  @Prop({ type: String })
  readonly settingsJsonUrl?: string;

  @Prop({ type: String })
  readonly socialsJsonUrl?: string;

  @Prop({ type: String })
  readonly customLabelsUrl?: string;

  xl!: Widget;

  mount = false;

  beforeMount() {
    const config: WidgetConfig = {
      projectId: this.projectId,
      clientId: this.clientId,
      callbackUrl: this.callbackUrl,
      redirectUri: this.redirectUri,
      scope: this.scope,
      responseType: this.responseType,
      state: this.state,
      payload: this.payload,
      preferredLocale: this.preferredLocale,
      settingsJSON: this.settingsJsonUrl,
      socialsJSON: this.socialsJsonUrl,
      theme: {
        scene: {
          color: 'transparent',
        },
      },
    };

    if (this.$appName === Apps.Township && TOWNSHIP_CUSTOM_LABELS_URL) {
      config.customLabels = TOWNSHIP_CUSTOM_LABELS_URL;
    }

    this.xl = new Widget(config as never);
  }

  mounted() {
    this.xl.on(this.xl.events.Close, this.handleClose);

    if (this.lazy) {
      return;
    }

    this.mountWidget();
  }

  beforeDestroy() {
    this.xl.off(this.xl.events.Close, this.handleClose);
  }

  @Watch('preferredLocale')
  localeChanged(locale: string) {
    this.xl.setLocale(locale);
  }

  open(from?: string) {
    if (!this.mount) {
      this.mountWidget();
    }

    this.xl.open();
    this.$emit('open', { from });
  }

  close() {
    this.xl.close();
  }

  mountWidget() {
    this.xl.mount(this.$el.id);

    this.mount = true;
  }

  handleClose() {
    this.close();

    this.$emit('close');
  }
}
